'use strict';


import { BufferGeometry, Float32BufferAttribute, Points, PointsMaterial, TextureLoader } from 'three';
import { projectMode, threeJsVariables } from '../../../settings';

export class StaticClouds {
    static #clouds = null;
    #active = config.features.staticClouds !== false;

    constructor () {
        if (projectMode.LiteMode.isActive() || !this.#active) return;

        const textureLoader = new TextureLoader();
        const URL = '/assets/textures/clouds/cloud-01.png';
        const texture = textureLoader.load(URL);

        const geometry = new BufferGeometry();
        const vertices = [];

        for ( let i = 0; i < 300; i ++ ) {

            let x = Math.random() * 700 - 350;
            let z = Math.random() * 700 - 350;
            let y = 370 + Math.random() * 370 * 2;

            vertices.push( x, y, z );
        }

        geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ));

        const material = new PointsMaterial({
            size: 350,
            sizeAttenuation: false,
            map: texture,
            transparent: true,
            depthWrite: false,
            alphaTest: 0
        });

        StaticClouds.#clouds = new Points(geometry,material);
        StaticClouds.#clouds.name = 'Static Clouds';

        threeJsVariables.scene.add(StaticClouds.#clouds);
        threeJsVariables.renderList.reorder();
    }

    static toggle(action) {
        if (!StaticClouds.#clouds) return;

        switch (action) {
            case 'show':
                StaticClouds.#clouds.visible = true;
                break;
            case 'hide':
                StaticClouds.#clouds.visible = false;
                break;
        }
    }

}
